import React, { useRef } from 'react';
import PropTypes from "prop-types";

import ErrorMessage from 'components/errorMessage/errorMessage';
import ToolTip from 'components/toolTipText/toolTipText';
import Label from 'components/label/label';
import styles from './input.scss';
function Input(props) {
    const inputRef = useRef(null);

    const { name, id, label, type, value, placeholder, required, touched, isValidChange, onChange, onBlur, onClick, helpTexts, inputContainerClass, inputClass, errors, showAllErrors, errorClass, invalidFieldClass, toolTipText, children, speechBubblePosition,onKeyDown, showDownArrow, ...optionalProps } = props;

    const renderHelpTexts = () => {
        if (helpTexts?.length > 0) {
            return (
                <div className={styles.instruction}>
                    {
                        helpTexts.map((helpText, index) => (
                            <p className={styles.helpText} key={index}>
                                <span className={styles.bullet}>*</span>{helpText}
                            </p>
                        ))
                    }
                </div>
            )
        } else {
            return null;
        }
    }

    return (
      <div className={`${inputContainerClass} ${styles.input_with_info}`}>
        {/* "input_with_info" this class should be came when info icon required */}
        <ErrorMessage
          {...{ errors, showAllErrors, errorClass, invalidFieldClass }}
          isErrorVisible={touched}
          renderChildren={(invalidFieldClass) => (
            <React.Fragment>
              <input
                {...optionalProps}
                type={type}
                id={id ?? name}
                name={name}
                key={name}
                value={value}
                placeholder={placeholder}
                required={required}
                onChange={(e) => isValidChange(e.target.value, e) && onChange(e.target.value, e)}
                onBlur={onBlur}
                onClick={onClick}
                onKeyDown={onKeyDown}
                className={`${inputClass} ${invalidFieldClass}`}
                ref={inputRef}
              />
              {label && (
                <Label
                  labelName={required ? label : `${label} (optional) `}
                  labelClass={`${styles.label} ${invalidFieldClass}`}
                />
              )}
              {showDownArrow && (
                <div
                  className={styles.downArrow}
                  onClick={() => {
                    inputRef.current.focus();
                  }}
                >
                  <i className="aeh-icon-chevron-down" />
                </div>
              )}
              {toolTipText && toolTipText.length > 0 && (
                <ToolTip toolTipText={toolTipText} speechBubblePosition={speechBubblePosition} />
              )}
              {children}
              {renderHelpTexts()}
            </React.Fragment>
          )}
        />
      </div>
    );
}

Input.defaultProps = {
    type: "text",
    required: false,
    value: "",
    touched: false,
    errors: [],
    placeholder: " ",
    isValidChange: value => true,
    inputClass: styles.input,
    inputContainerClass: styles.inputContainer,
    invalidFieldClass: styles.error,
}

Input.propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    touched: PropTypes.bool,
    isValidChange: PropTypes.func,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onClick: PropTypes.func,
    helpTexts: PropTypes.array,
    inputClass: PropTypes.string,
    inputContainerClass: PropTypes.string,
    errors: PropTypes.array,
    showAllErrors: PropTypes.bool,
    errorClass: PropTypes.string,
    invalidFieldClass: PropTypes.string,
    children: PropTypes.element
}

export default Input
